import Grid from '@mui/material/Grid';
import { FC, memo, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { useStoreState } from '~/store/hooks';
import formatClientAddress from '~/utils/dataFormat/formatClientAddress';
import Input from '~/ui/components/inputs/Input';
import InputMask from '~/ui/components/inputs/InputMask';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';

import addressAdditionalOption from '~/ui/pages/Visits/constants/addressAdditionalOption';
import { IOption } from '~/types';

interface IProps {
  states: IOption[];
}

const VisitAddress: FC<IProps> = ({ states }) => {
  const { addresses } = useStoreState(state => state.clientDetails);

  const {
    control,
    watch,
    clearErrors,
    formState: { errors },
    register,
  } = useFormContext();

  const address = watch('address');

  useEffect(() => {
    if (address) {
      clearErrors(['city', 'line1', 'stateId', 'zipCode']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  const filteredAddresses = useMemo(() => {
    const newAddresses = addresses.reduce((acc, obj) => {
      if (!obj.isArchived) {
        acc.push({ value: obj.id, label: formatClientAddress(obj) });
      }

      return acc;
    }, []);

    newAddresses.unshift(addressAdditionalOption);

    return newAddresses;
  }, [addresses]);

  return (
    <>
      <Grid
        size={{
          sm: 9,
        }}
      >
        <Select
          hideSelectedOptions={false}
          name="address"
          options={filteredAddresses}
          control={control}
          errors={errors}
          label="Select Address"
        />
      </Grid>
      {!address && (
        <>
          <Grid
            size={{
              sm: 12,
            }}
          >
            <h4>Address</h4>
          </Grid>
          <Grid
            size={{
              sm: 3,
            }}
          >
            <Input type="text" register={register} errors={errors} name="city" label="City" />
          </Grid>
          <Grid
            size={{
              sm: 3,
            }}
          >
            <Select
              control={control}
              errors={errors}
              name="stateId"
              label="State"
              options={states}
              hideSelectedOptions={false}
              openMenuOnFocus
            />
          </Grid>
          <Grid
            size={{
              sm: 3,
            }}
          >
            <InputMask
              control={control}
              errors={errors}
              name="zipCode"
              label="Zip Code"
              alwaysShowMask={false}
              mask="99999"
            />
          </Grid>
          <Grid
            size={{
              sm: 9,
            }}
          >
            <Input type="text" register={register} errors={errors} name="line1" label="Address" />
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(VisitAddress);
